module.exports = __webpack_public_path__ + "img/i7.0d1c5995.svg";